import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const ATTRIBUTION_DAYS = 90;

// Captures ?ref=CODE on any page, stores in localStorage for 90 days, pings backend to count click.
export default function ReferralCapture() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('ref');
    if (!code) {
      // Check if existing stored code expired
      const exp = localStorage.getItem('ref_code_exp');
      if (exp && Date.now() > Number(exp)) {
        localStorage.removeItem('ref_code');
        localStorage.removeItem('ref_code_exp');
      }
      return;
    }
    const existing = localStorage.getItem('ref_code');
    const expiry = Date.now() + ATTRIBUTION_DAYS * 24 * 60 * 60 * 1000;
    localStorage.setItem('ref_code', code);
    localStorage.setItem('ref_code_exp', String(expiry));
    // Only ping click endpoint if it's a new code visit
    if (existing !== code) {
      axios.post(`${API}/api/affiliate/track-click`, { code }).catch(() => {});
    }
  }, [location.search]);

  return null;
}
